import React from 'react';
const CARDS = [{
  title: 'Broken Window Glass',
  copy: "A broken home window can affect safety, comfort and curb appeal. Kosin's Glass can replace cracked, shattered or damaged glass and help restore your window's clear view."
}, {
  title: 'Foggy Double-Pane Glass',
  copy: "Condensation or cloudiness between panes usually points to a failed insulated-glass seal. Kosin's Glass can inspect the unit and recommend the right repair or replacement option."
}, {
  title: 'Insulated & Low-E Glass',
  copy: 'Ask about insulated glass and Low-E glass replacement options that may help improve comfort and reduce heat transfer compared with older or damaged glass.'
}];
export function ProblemSolution() {
  return <section className="py-16 lg:py-24 px-4 sm:px-6 lg:px-8 bg-navy-900 text-white" data-id="element-1324">
      <div className="max-w-7xl mx-auto" data-id="element-1325">
        <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-1326">
          <h2 className="text-3xl sm:text-4xl font-bold tracking-tight mb-6" data-id="element-1327">
            Broken, Cracked or Foggy Window Glass?
          </h2>
        </div>
        <ul className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-12" data-id="element-1328">
          {CARDS.map((card, idx) => <li key={idx} className="bg-navy-800 rounded-2xl p-8 border border-navy-700 anim-on-scroll" data-id="element-1329">
              <h3 className="text-2xl font-bold mb-4 text-brandBlue-400" data-id="element-1330">
                {card.title}
              </h3>
              <p className="text-slate-300 leading-relaxed" data-id="element-1331">{card.copy}</p>
            </li>)}
        </ul>
        <div className="text-center" data-id="element-1332">
          <a href="#estimate-form" className="inline-flex items-center justify-center bg-brandBlue-600 hover:bg-brandBlue-500 text-white font-bold text-lg py-4 px-8 rounded-xl transition-colors shadow-md" data-id="element-1333">
            Request a Window Glass Quote
          </a>
        </div>
      </div>
    </section>;
}